import { writable } from 'svelte/store'

function buildCustomStore() {
    const { subscribe, set, update } = writable(0)

    return {
        subscribe,
        append: (n) => {
            update((i) => i + n)
        },
        reset: () => set(0),
    }
}

const count = buildCustomStore()
export default count
